// extracted by mini-css-extract-plugin
export default {"inner":"rpUV5zswiNdLnx_f4xwu","content":"vHjziiWFAFrIGSvKhVXX","title":"y1Sk5_ODD9Y9pVLtVoRe","headerWithLink":"Y9FCc7qM52Vdw8gQcCd4","titleWrapper":"AMexusis6yhFWMVL5EwW"};